import React, { useEffect } from "react"
import { useDispatch } from "react-redux"

import ClientPickerTable from "./components/ClientPickerTable"
import OpenRunBanner from "./components/OpenRunBanner"
import SweepResult from "./components/SweepResult"
import { fetchEligibleClients } from "./clientBatchingSlice"

export default function ClientBatchingPage() {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchEligibleClients())
    }, [dispatch])

    return (
        <div>
            <OpenRunBanner />
            {/* Above the picker on purpose: the client list runs to dozens of rows, so a result
                rendered underneath it is off-screen and the sweep looks like it did nothing. */}
            <SweepResult />
            <ClientPickerTable />
        </div>
    )
}
